/* ==========================================================================
   16 MATCHA — WHOLESALE
   Lightweight scroll reveal
   — No dependencies
   — IntersectionObserver only
   — Shopify Theme Editor compatible
   ========================================================================== */

(() => {
  if (window.JHCWholesale) return;

  const observers = new WeakMap();

  const reduceMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initSection(section) {
    if (!section || observers.has(section)) return;

    const reveals = [...section.querySelectorAll("[data-reveal]")];

    if (!reveals.length || reduceMotion() || !("IntersectionObserver" in window)) {
      reveals.forEach((el) => {
        el.classList.remove("jhc-reveal-armed");
        el.classList.add("is-visible");
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -6% 0px"
      }
    );

    reveals.forEach((el) => {
      if (el.classList.contains("is-visible")) return;

      /*
       * Important:
       * Content is visible by default.
       * We only hide it immediately before observing.
       * This prevents permanently hidden content if JS fails.
       */
      el.classList.add("jhc-reveal-armed");
      observer.observe(el);
    });

    observers.set(section, observer);
  }

  function destroySection(section) {
    const observer = observers.get(section);

    if (observer) {
      observer.disconnect();
      observers.delete(section);
    }
  }

  function initAll() {
    document
      .querySelectorAll("[data-wholesale-section]")
      .forEach(initSection);
  }

  /* Initial page load */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  /* Shopify Theme Editor — section added/reloaded */
  document.addEventListener("shopify:section:load", (event) => {
    const section =
      event.target.matches?.("[data-wholesale-section]")
        ? event.target
        : event.target.querySelector?.("[data-wholesale-section]");

    initSection(section);
  });

  /* Shopify Theme Editor — section removed */
  document.addEventListener("shopify:section:unload", (event) => {
    const section =
      event.target.matches?.("[data-wholesale-section]")
        ? event.target
        : event.target.querySelector?.("[data-wholesale-section]");

    if (section) destroySection(section);
  });

  /* Keep selected Theme Editor blocks visible while editing */
  document.addEventListener("shopify:block:select", (event) => {
    const reveal = event.target.closest?.("[data-reveal]");

    if (!reveal) return;

    reveal.classList.add("is-visible");
  });

  window.JHCWholesale = {
    init: initAll
  };
})();